(function () {
    'use strict';

    var module = angular.module('uwAgenda.agenda');

    // directive for agenda appointment status
    module.directive('agendaAppointmentPaymentStatus', [
        '$rootScope',
        'AppointmentService',
        'Alert',
        '$translate',
        'AgendaBroadcast', 
        'WebsocketService',
        'WebsocketRegisterType',        
        function (
            $rootScope,
            AppointmentService,
            Alert,
            $translate,
            AgendaBroadcast,
            WebsocketService,
            WebsocketRegisterType) {

        var directive = {
            restrict: 'E',
            templateUrl: '/app/agenda/templates/agenda-appointment-payment-status.template.html',
            scope: {
                appointmentId: '=',
                agendaId: '=',
                amount: '=',
                isPaid: '=',
            },
            link: link
        };
        return directive;

        function link(scope, element) {

            activate();

            function listen() {
                var wsAppointmentPaymentUpdated = WebsocketService.register(WebsocketRegisterType.AppointmentPaymentUpdate, function (obj) {

                    if (obj.data.appointmentId === scope.appointmentId) {
                        
                        if (obj.data.isPaid){
                            scope.isPaid = true;
                            let appointmentDate = moment(obj.data.date);
                            let paidMessage = $translate.instant('amount_for_appointment_is_paid', {amount: obj.data.amount, datetime: appointmentDate.format('dddd DD MMMM YYYY H:mm')});
                            
                            Alert.success(paidMessage);
                        }
                    }
                });


                // on destroy
                scope.$on("$destroy", function () {
                    if (wsAppointmentPaymentUpdated) {
                        WebsocketService.unregister(wsAppointmentPaymentUpdated.id);
                    }
                });

            }

            // change state of appointment
            scope.resendPaymentInvite = function () {
                AppointmentService.resendPaymentInvite(scope.appointmentId, scope.agendaId)
                    .then(function () {
                        let successMessage = $translate.instant('email_scheduled');
                        Alert.success(successMessage);

                    });
            };

            

            // activation work
            function activate() {
                           
                listen();               
            }
        }
}]);
})();